import React from 'react'
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";

import FormPage from '../FormPage'

class ResetPassword extends FormPage
{

	/**
	 * The css class for the page container
	 *
	 * @var {String}
	 */
	static BGClass = 'bordered-panel';

    static path = '/password/reset/:token';

	/**
	 * The title shown on the form
	 */
	static FormTitle = 'passwords.reset.title';

	/**
	 * The subtitle shown on the form
	 */
	static FormSubtitle = "passwords.reset.subtitle";

	/**
	 * The submit button title for the form
	 */
	static FormSubmit = 'passwords.reset.submit_button';

	/**
     * The api endpoint path that the form should send a post request to
     */
	static FormPost = "/api/passwords/reset";

	/**
     * The fields mapping for the form
     */
    static FormFields = {
    	email: {
            type: 'email',
			label: 'passwords.reset.email_label',
        },
        password: {
            type: 'password',
			label: 'passwords.reset.password_label',
            autoComplete: 'new-password'
        },
        password_confirmation: {
            type: 'password_confirmation',
            label: 'passwords.reset.password_confirmation_label'
        }
    };

    /**
     * The links mapping for the form
     */
    static FormLinks = [
       	{
			title: 'passwords.reset.login_link',
			path: '/login',
		}
   	];

    /**
     * Whether or not an alert should show if the user tries to navigate to another page or close the browser
     *
     * @var {Boolean}
     */
    static ShowsUnloadWarning = false;

   	/**
     * Maps form input data to form submit model
     * Appends token to form data from url route parameter
     *
     * @param {Object} model
     * @returns {Object}
     */
	mapping(model)
	{
		model.token = this.props.token;

		return model;
	}

   	/**
     * Handles successful responses returned by TB Request
     *
     * @param {Object} responseData
     * @returns void
     */
	onSuccess(responseData)
	{
		TB.alert(
			'success',
			'passwords.reset.success.title',
			'passwords.reset.success.message', [
				{
					title: 'passwords.reset.success.login_link',
					click: '/login'
				}
			]
		);
	}
}

export default () => {
    const {token} = useParams();
    return (
		<>
			<Helmet>
				<title>Reset Password | Wripple</title>
			</Helmet>
        	<ResetPassword token={token} />
		</>
    )
}
